import { IQueryMediator } from 'core-ts-types';
import { ORM } from 'utility-ts-orm';
import { PollAnswerDataStore } from '../datastore/poll_answer_datastore';
import { PollDataStore } from '../datastore/poll_datastore';
import { PollStudentDataStore } from './../datastore/poll_student_datastore';
import { PollQueryModel } from './../queries/poll_query_model';

angular
  .module('capability-ng-poll')
  .factory(
    'loadPathPollCommand',
    function loadPathPollCommandDeinition(
      $q: ng.IQService,
      QueryMediator: IQueryMediator,
      $http: ng.IHttpService,
      ngPollDataStore: PollDataStore,
      ngPollStudentDataStore: PollStudentDataStore,
      ngPollAnswerDataStore: PollAnswerDataStore,
      ngPollQueryModel: PollQueryModel,
      ngPollResultsServant: any,
      defineCommand: any
    ): void {
      return defineCommand(
        'loadPathPollCommand',
        function loadPathPollCommand(deferred: ng.IDeferred<any>, id: string) {
          $q.all({
            poll: $http.get(`poll/${id}/definition`),
            first_quesiton: $http.get(`poll/${id}/firstquestion/`),
            poll_student: $http.get(`poll/${id}/student`, { cache: false })
          })
            .then(({ poll, first_quesiton, poll_student }): void => {
              ngPollDataStore.write({
                ...poll.data,
                first_question_id: first_quesiton.data.next_question_id
              });
              ngPollAnswerDataStore.write({ answer: first_quesiton.data.next_question_answers });
              ngPollStudentDataStore.write(poll_student.data);

              ngPollDataStore.addBuiltQuestions(
                ngPollResultsServant.buildQuestions(
                  ngPollDataStore.read(),
                  ngPollAnswerDataStore.read(),
                  ngPollStudentDataStore.read()
                )
              );

              ngPollQueryModel.isUpdatedPoll = true;

              deferred.resolve();
              ORM.run(ngPollDataStore, ngPollAnswerDataStore, ngPollStudentDataStore);
            })
            .catch((err) => {
              deferred.reject(err);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/commands/load_poll_command.ts